import { render, staticRenderFns } from "./CalcCompliancePage.vue?vue&type=template&id=0771b871"
import script from "./CalcCompliancePage.vue?vue&type=script&lang=js"
export * from "./CalcCompliancePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports